<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>

        <!-- 表单信息 -->
        <div class="main-title">企业楣板字及会刊信息</div>
        <el-form
          ref="formData"
          label-position="top"
          class="form"
          :model="formData"
          label-width="140px"
          :rules="formRules"
        >
          <el-form-item label="公司logo：" prop="logo" style="width: 100%">
            <div class="image" v-if="formData.logo">
              <el-image :src="$imgUrl + formData.logo"></el-image>
              <div class="upload-span">
                <span
                  class="upload-icon"
                  @click.stop="
                    handlePictureCardPreview($imgUrl + formData.logo)
                  "
                  ><i class="el-icon-zoom-in"></i
                ></span>
                <span
                  class="upload-icon"
                  @click.stop="handleRemove()"
                  style="margin-left: 20px"
                  ><i class="el-icon-delete"></i
                ></span>
              </div>
            </div>

            <div v-if="!formData.logo">
              <el-upload
                :action="$Url"
                list-type="picture-card"
                :headers="headers"
                :multiple="false"
                :on-success="handleLogoSuccess"
                :on-error="handleLogoError"
                :show-file-list="false"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>

            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item
            label="对外宣传企业名称（楣板字）（中文）："
            prop="lintel_cn"
          >
            <el-input
              v-model="formData.lintel_cn"
              clearable
              placeholder="请输入产品名称（中文）"
            />
          </el-form-item>
          <el-form-item label="对外宣传企业名称（楣板字）（英文）：">
            <el-input
              v-model="formData.lintel_en"
              clearable
              placeholder="请输入产品名称（英文）"
            />
          </el-form-item>
          <el-form-item label="品牌归属地（境内/海外）：" prop="country_area">
            <el-cascader
              style="width: 100%"
              v-model="formData.country_area"
              :options="locationdata"
              clearable
            ></el-cascader>
            <!--<el-input v-model="formData.country_area" clearable placeholder="请输入国家地区" />-->
          </el-form-item>
          <el-form-item label="网址：" prop="model">
            <el-input
              v-model="formData.web"
              clearable
              placeholder="请输入网址"
            />
          </el-form-item>
          <el-form-item label="电话：" prop="manufacturer">
            <el-select v-model="telephonesel" style="margin-right: 15px">
              <el-option
                v-for="item in codedata"
                :key="item.id"
                :label="item.country + ' ' + item.phone_code"
                :value="item.phone_code"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="formData.telephone"
              clearable
              placeholder="请输入电话"
            />
          </el-form-item>
          <el-form-item label="传真：" prop="manufacturer">
            <el-select v-model="facsimilesel" style="margin-right: 15px">
              <el-option
                v-for="item in codedata"
                :key="item.id"
                :label="item.country + ' ' + item.phone_code"
                :value="item.phone_code"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="formData.facsimile"
              clearable
              placeholder="请输入传真"
            />
          </el-form-item>
          <el-form-item label="邮箱：" prop="contacts">
            <el-input
              v-model="formData.email"
              clearable
              placeholder="请输入邮箱"
            />
          </el-form-item>
          <el-form-item label="邮编：" prop="mobile">
            <el-input
              v-model="formData.postal_code"
              clearable
              placeholder="请输入邮编"
            />
          </el-form-item>
          <el-form-item label="地址：" prop="email">
            <el-input
              v-model="formData.address"
              clearable
              placeholder="请输入地址"
            />
          </el-form-item>
          <el-form-item label="英文地址：" prop="email">
            <el-input
              v-model="formData.address_en"
              clearable
              placeholder="请输入英文地址"
            />
          </el-form-item>
          <el-form-item label="公司中文简介：" prop="purpose">
            <el-input
              maxlength="600"
              show-word-limit
              v-model="formData.introduction_cn"
              type="textarea"
              rows="4"
              resize="none"
              clearable
              placeholder="请输入产品用途"
            />
          </el-form-item>
          <el-form-item label="公司英文简介：" prop="performance">
            <el-input
              maxlength="600"
              show-word-limit
              v-model="formData.introduction_en"
              type="textarea"
              rows="4"
              resize="none"
              clearable
              placeholder="请输入产品性能指标"
            />
          </el-form-item>
        </el-form>
        <el-button @click="submit('formData')">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { companyDetails, editCompany } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "shellScheme",
  data() {
    return {
      active: 3,
      loading: false,
      telephonesel: "",
      facsimilesel: "",
      formData: {
        logo: "",
        lintel_cn: "",
        lintel_en: "",
        country_area: "",
        web: "",
        telephone: "",
        facsimile: "",
        email: "",
        postal_code: "",
        address: "",
        address_en: "",
        introduction_cn: "",
        introduction_en: "",
      },
      fileList: [],
      locationdata: [],
      calloptions: [],
      codedata: [],
      headers: {},
      dialogVisible: false,
      dialogImageUrl: "",
      mark: "",
      formRules: {
        lintel_cn: [{ required: true, message: "请选择", trigger: "blur" }],
        country_area: [{ required: true, message: "请选择", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.codedata = JSON.parse(localStorage.getItem("codedata"));
    this.locationdata = JSON.parse(localStorage.getItem("locationdata"));
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    // 设置当前选中的左侧菜单
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "standPrepare";
    });
    this.active = index;
    this.mark = this.$route.query.mark;
    //  获取详情
    this.getBuilding();
  },
  created() {},
  methods: {
    handleRemove(file, fileList) {
      this.formData.logo = "";
    },
    // logo上传成功
    handleLogoSuccess(resData, file, fileList) {
      this.formData.logo = resData.data.url;
    },
    // logo上传失败
    handleLogoError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    // 返回
    goBack() {
      this.$router.back();
    },

    //  获取详情
    getBuilding() {
      companyDetails({})
        .then((res) => {
          console.log(res.data, "======res");
          if (res.data.code == 1) {
            let data = res.data.data;
            this.formData.lintel_cn = data.lintel_cn;
            this.formData.lintel_en = data.lintel_en;
            this.formData.web = data.web;
            this.formData.email = data.email;
            this.formData.postal_code = data.postal_code;
            this.formData.address = data.address;
            this.formData.address_en = data.address_en;
            this.formData.introduction_cn = data.introduction_cn;
            this.formData.introduction_en = data.introduction_en;

            if (data.logo) {
              this.formData.logo = data.logo;
            }
            this.formData.country_area = data.country_area
              .split("-")
              .join(",")
              .split(",");
            this.telephonesel = data.telephone
              .split("-")
              .join(",")
              .split(",")[0];
            this.formData.telephone = data.telephone
              .split("-")
              .join(",")
              .split(",")[1];
            this.facsimilesel = data.telephone
              .split("-")
              .join(",")
              .split(",")[0];
            this.formData.facsimile = data.facsimile
              .split("-")
              .join(",")
              .split(",")[1];
          }
        })
        .catch((err) => {});
    },
    //保存
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.formData;
          data.mark = this.mark;
          // if(this.fileList.length>0){
          //   this.formData.logo=this.fileList[0].response.data.url;
          // }

          if (this.telephonesel) {
            data.telephone = this.telephonesel + "-" + data.telephone;
          }
          if (this.facsimilesel) {
            data.facsimile = this.facsimilesel + "-" + data.facsimile;
          }
          editCompany(data)
            .then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                this.goBack();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;
  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}
/deep/ .el-upload--picture-card {
  width: 146px;
  height: 146px;
}
/deep/ .el-upload {
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-form-item__content {
  display: flex;
}
.form {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 100px;
  width: 100%;
  background: #fff;
  padding: 40px;
  box-sizing: border-box;
}
.form .el-form-item {
  width: 45%;
  margin-right: 60px;
}
.avatar-uploader {
  width: 152px;
  height: 152px;
  overflow: hidden;
  background: #f5f5f5;
  border-radius: 2px;
  border: 1px dashed #bfbfbf;
}
.pd {
  padding: 30px;
}
.shell-type {
  background: #fff;
  border-radius: 6px;
}
.mb0 {
  margin-bottom: 0 !important;
}
// 展商信息
.ex-infor {
  margin-top: 50px;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 10px solid #f2f4f8;
  .ex-wrap {
    color: #2c2c2e;
    .ex-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 37px;
    }
    .ex-content {
      width: 87%;
      max-width: 465px;
      height: auto;
      padding: 23px;
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      background: linear-gradient(90deg, #e4ecfd 0%, #f9fbff 100%);
      border-radius: 18px;
      > div {
        margin-bottom: 13px;
      }
      .ex-tinfor {
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        .ex-left {
          width: 56px;
          height: 20px;
          display: inline-block;
          text-align: justify;
          &:after {
            content: "";
            display: inline-block;
            width: 100%;
          }
        }
        .ex-right {
          flex: 1;
        }
      }
    }
  }
}
.main-title {
  margin: 40px 0 20px;
}
//楣板字相关
.shell-wrap {
  color: #000;
  font-size: 20px;
  line-height: 28px;
  .shell-choose {
    margin-top: 13px;
    margin-bottom: 30px;
    .el-radio__label {
      font-size: 18px;
    }
    .el-radio__input.is-checked .el-radio__inner {
      background: #fff;
    }
    .el-radio__inner {
      border-width: 2px;
    }
    .el-radio__inner::after {
      width: 7px;
      height: 7px;
      background: #409eff;
    }
  }
  .shell-input {
    width: 600px;
    height: 50px;
    display: block;
    margin-top: 5px;
    margin-bottom: 12px;
    .el-input__inner {
      height: 50px;
      font-size: 20px;
      line-height: 50px;
      border-radius: 9px;
    }
    .el-textarea__inner {
      height: 100%;
      resize: none;
      padding: 10px 15px;
      font-size: 20px;
      border-radius: 9px;
    }
  }
  .shell-item {
    width: 240px;
    margin-top: 5px;
    margin-right: 20px;
    .shell-img {
      color: #ccc;
      background: #f5f5f5;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-image__inner {
        max-width: 240px;
        max-height: 250px;
        width: auto !important;
        height: auto !important;
      }
    }
    .shell-text {
      color: #999;
      font-size: 14px;
      text-align: center;
    }
  }
}

@media only screen and (max-width: 767px) {
  .content {
    width: 92%;
    padding: 30px 0 130px 0;
  }
  .shell-type {
    width: 100%;
    margin: auto;
  }
  .el-input__inner {
    width: 90% !important;
  }
  .shell-input {
    width: 100% !important;
  }
  .form .el-form-item {
    width: 100% !important;
    margin-right: 0 !important;
  }
}
</style>